import moment from 'moment'
import {mapKeys} from 'lodash'
import React from 'react'
import Text from 'react-text'
import UploadLinks from './upload-links'
import prettyBytes from 'pretty-bytes'
import {enhancedWithRowData, enhancedWithSortColumns} from '../../helpers/utils'

function MyLessonsHeader ({sortColumns, title}) {
  const active = sortColumns && sortColumns.id == title
  const direction = active ? (sortColumns.sortAscending ? 'ascending' : 'descending') : ''
  return (
    <span className="sorted-column-wrapper">
      <span className={direction}/>
      <span><Text id={`${title}_my_lessons_header`} /></span>
    </span>
  )
}

function EmptyHeader () { return (<span />) }

function UploadColumn ({rowData}) {
  const {name, assigned} = rowData
  const assignedClass = `name${assigned ? ' assigned' : ''}`
  return (
    <div className={assignedClass} title={name}>
      <div className="bullet"></div>
      {name}
    </div>
  )
}

function ByteLengthColumn ({value}) {
  return (<div className="size">{prettyBytes(value || 0)}</div>)
}

function DateColumn ({value}) {
  return (<div className="modified">{moment(value).format('L, LT')}</div>)
}

function LessonLinksColumn ({rowData}) {
  const map = { lesson: 'id', lessonName: 'name'}
  const props = mapKeys(rowData, (_, key) => map[key] || key)
  return (<UploadLinks {...props} />)
}

const map = {
  headers: {MyLessonsHeader: enhancedWithSortColumns(MyLessonsHeader), EmptyHeader},
  columns: {
    UploadColumn: enhancedWithRowData(UploadColumn),
    LessonLinksColumn: enhancedWithRowData(LessonLinksColumn),
    ByteLengthColumn,
    DateColumn
  }
}

export default map
